const renderTypeDefaults = {
  id: { width: 180, min: 160, max: 280, ellipsis: true },
  enum: { width: 140, min: 100, max: 400 },
  enumList: { width: 300, min: 160, max: 500 },
  avatar: { width: 80, min: 64, max: 200 },
  avatarList: { width: 160, min: 120, max: 400 },
  file: { width: 200, min: 120, max: 400 },
  fileList: { width: 300, min: 160, max: 500 }
};

export default renderTypeDefaults;
